<div class="vh-100 d-flex flex-column">
	<div class="flex-grow-1">
		<div class="d-lg-none">
			<app-mobile-header [theme]="'neutral'" [showWatchlist]="true" />
		</div>
		<div class="d-none d-lg-block">
			<app-header [searchbarIsVisible]="showSearchInNavbar" [showWatchlist]="true"></app-header>
		</div>
	</div>
	<div class="h-100 overflow-auto">
		<div class="h-100 d-flex flex-column">
			<img
				class="w-100 position-absolute"
				style="left: 0; top: 0; z-index: -1"
				src="/assets/home/HomeBackground.svg"
				alt="background" />
			<div class="d-flex flex-column h-100 align-items-center justify-content-center">
				<img src="assets/material/error_outline-24px.svg" alt="maintenance" class="mb-4" />
				<div class="d-flex justify-content-center text-center">
					<h1 class="h1">{{ 'global.errorpages.hoppla' | translate }}</h1>
				</div>
				<div class="d-flex justify-content-center text-center px-3">
					<h2 class="h2 mb-4">{{ 'global.errorpages.catalog-notavailable' | translate }}</h2>
				</div>
				<div class="d-flex justify-content-center text-center px-3 linebreak-after-backslash-n">
					<p class="text-large">{{ 'global.errorpages.catalog-notavailable-hint' | translate }}</p>
				</div>
				<div class="d-flex flex-row justify-content-center mt-3 pb-3">
					<div class="bg-white mx-4" style="width: 180px">
						<a type="button" class="btn btn-outline-dark w-100" routerLink="/">
							{{ 'global.errorpages.home' | translate }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="grid-footer">
		<app-footer></app-footer>
	</div>
</div>
